<template>
  <div class="col-12 col-lg-6">
    <!-- Upcoming Events -->
    <div class="upcoming-events mb-100">
        <!-- Headline -->
        <div class="headline d-none d-sm-block">            
            <h3>Próximos Eventos</h3>
        </div>

        <!-- Single Upcoming Events -->
        <div class="single-upcoming-events d-flex align-items-center">
            <!-- Events Date & Thumbnail -->
            <div class="event-date-thumbnail d-flex align-items-center">
                <div class="event-date">
                    <h6>Martes <br> Ago <br> 2020</h6>
                </div>
                <div class="event-thumbnail bg-img" style="background-image: url(img/bg-img/event1.jpg);"></div>
            </div>
            <!-- Events Content -->
            <div class="events-content">
                <a href="#">
                    <h6>Servicio General</h6>
                </a>
                <p>8:00 pm @ Iglesia </p>
            </div>
        </div>

        <!-- Single Upcoming Events -->
        <div class="single-upcoming-events d-flex align-items-center">
            <!-- Events Date & Thumbnail -->
            <div class="event-date-thumbnail d-flex align-items-center">
                <div class="event-date">
                    <h6>Viernes <br> Ago <br> 2020</h6>
                </div>
                <div class="event-thumbnail bg-img" style="background-image: url(img/bg-img/event2.jpg);"></div>
            </div>
            <!-- Events Content -->
            <div class="events-content">
                <a href="#">
                    <h6>Reunión de Hogar</h6>
                </a>
                <p>8:00 pm @ Hogares</p>
            </div>
        </div>

        <!-- Single Upcoming Events -->
        <div class="single-upcoming-events d-flex align-items-center">
            <!-- Events Date & Thumbnail -->
            <div class="event-date-thumbnail d-flex align-items-center">
                <div class="event-date">
                    <h6>Domingo <br> Ago <br> 2020</h6>
                </div>
                <div class="event-thumbnail bg-img" style="background-image: url(img/bg-img/event3.jpg);"></div>
            </div>
            <!-- Events Content -->
            <div class="events-content">
                <a href="#">
                    <h6>Servicio General</h6>
                </a>
                <p>8:00 pm @ Iglesia</p>
            </div>
        </div>

        <!-- Single Upcoming Events -->
        <div class="single-upcoming-events d-flex align-items-center">
            <!-- Events Date & Thumbnail -->
            <div class="event-date-thumbnail d-flex align-items-center">
                <div class="event-date">
                    <h6>Domingo <br> Jun <br> 2020</h6>
                </div>
                <div class="event-thumbnail bg-img" style="background-image: url(img/bg-img/event4.jpg);"></div>
            </div>
            <!-- Events Content -->
            <div class="events-content">
                <a href="#">
                    <h6>Práctica BQ</h6>
                </a>
                <p>8:00 pm @ Iglesia</p>
            </div>
        </div>

        <div class="all-events-btn">
            <a href="#" class="btn faith-btn active">Ver Calendario</a>
        </div>

    </div>
</div>
</template>

<script>
export default {

}
</script>

<style>

</style>